export const GLOBAL_STATE = 'Category'

export const CATEGORY = 'CATEGORY' as const
export const CATEGORY_LIST = 'CATEGORY_LIST' as const
export const CATEGORY_ALL = 'CATEGORY_ALL' as const
export const CATEGORY_CREATE = 'CATEGORY_CREATE' as const
export const CATEGORY_DELETE = 'CATEGORY_DELETE' as const
